import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { docusealService } from "@/services/docuseal";
import { queryKeys } from "@/queryKeys";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const GENERAL = "general";

interface JurisdictionSelectProps {
  id: string;
  /** Catalog code, or null for the general disclosure. */
  value: string | null;
  onChange: (code: string | null) => void;
  disabled?: boolean;
}

/** Picker for a pre-disclosure's jurisdiction lane. "General" is the null lane. */
const JurisdictionSelect: React.FC<JurisdictionSelectProps> = ({
  id,
  value,
  onChange,
  disabled,
}) => {
  const { data } = useQuery({
    queryKey: queryKeys.jurisdictions(),
    queryFn: () => docusealService.listJurisdictions(),
  });
  const options = useMemo(
    () => [...(data?.jurisdictions ?? [])].sort((a, b) => a.name.localeCompare(b.name)),
    [data]
  );

  return (
    <Select
      value={value ?? GENERAL}
      onValueChange={(next) => onChange(next === GENERAL ? null : next)}
      disabled={disabled}
    >
      <SelectTrigger id={id} aria-label="Jurisdiction">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={GENERAL}>General</SelectItem>
        {options.map((row) => (
          <SelectItem key={row.code} value={row.code}>
            {row.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default JurisdictionSelect;
